import React from "react";

const SalaryComponentToolbar = ({
  search,
  setSearch,
  typeFilter,
  setTypeFilter,
  statusFilter,
  setStatusFilter,
  onAdd,
}) => {
  return (
    <div className="salary-toolbar">

      <div className="salary-toolbar-left">

        <input
          type="text"
          className="salary-search"
          placeholder="Search Component..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="salary-filter"
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
        >
          <option value="All">All Types</option>
          <option value="Earning">Earning</option>
          <option value="Deduction">Deduction</option>
        </select>

        <select
          className="salary-filter"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="All">All Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>

      </div>

      <button
        className="btn btn-primary"
        onClick={onAdd}
      >
        + Add Component
      </button>

    </div>
  );
};

export default SalaryComponentToolbar;